class ApiAdapterError extends Error {
    constructor(...args) {
        super(...args);
        Error.captureStackTrace(this, ApiAdapterError);
    }
}

export default ApiAdapterError;
